import styled from 'styled-components';

export default styled.div`
  justify-content: space-between;
  position: absolute;

  display: flex;
  bottom: -30px;

  height: 60px;
  width: 100%;

  z-index: 1;
  left: 0px;

  @media only screen and (max-width: 359px) {
    height: 50px;
  }

  > button {
    padding: 0px;
    max-width: 125px;

    @media only screen and (max-width: 359px) {
      max-width: 108px;
      height: 50px;
    }

    &:nth-child(2) {
      flex-direction: column;
      border-radius: 50%;
      height: 100%;
      width: 60px;

      > span {
        font-weight: bold;
        margin-top: 6px;
        font-size: 12px;
        line-height: 1;
      }

      @media only screen and (max-width: 359px) {
        width: 50px;

        > svg {
          width: 16px;
        }

        > span {
          font-size: 10px;
        }
      }
    }

    > svg path {
      transition: fill 0.3s;
    }
  }

  > button:first-child svg {
    transform: rotate(180deg);
    transform-origin: center;
    margin-right: 16px;

    @media only screen and (max-width: 359px) {
      margin-right: 8px;
    }
  }

  > button:last-child svg {
    margin-left: 16px;

    @media only screen and (max-width: 359px) {
      margin-left: 8px;
    }
  }
`;
